module.exports = __webpack_public_path__ + "media/images/img_service_step_6-8c9477d9a84fca021ba2fedd5dca71d2.png";